
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/currency-converter/currencies",
      function () {
        return require("private-next-pages/currency-converter/currencies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/currency-converter/currencies"])
      });
    }
  